import { render, staticRenderFns } from "./AutomationSMSContentNew.vue?vue&type=template&id=3ee22fb7&scoped=true&"
import script from "./AutomationSMSContentNew.vue?vue&type=script&lang=js&"
export * from "./AutomationSMSContentNew.vue?vue&type=script&lang=js&"
import style0 from "./AutomationSMSContentNew.vue?vue&type=style&index=0&id=3ee22fb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee22fb7",
  null
  
)

export default component.exports